import React from "react";

export default function ReactionParticlesLayer({ particles = [] }) {
  if (!Array.isArray(particles) || particles.length === 0) return null;

  const renderItem = (item) => {
    if (item?.type === "ripple") {
      return (
        <span
          key={item.id}
          className="reaction-ripple"
          style={{
            "--rr-x": `${item.x}px`,
            "--rr-y": `${item.y}px`,
            "--rr-size": `${item.size}px`,
            "--rr-color": String(item.color || "rgba(255, 255, 255, 0.55)"),
            "--rr-life": `${item.lifeMs}ms`,
            "--rr-delay": `${item.delayMs}ms`,
          }}
        />
      );
    }

    if (item?.type === "dot") {
      return (
        <span
          key={item.id}
          className="reaction-particle reaction-particle--dot"
          style={{
            "--rd-x": `${item.x}px`,
            "--rd-y": `${item.y}px`,
            "--rd-dx": `${item.dx}px`,
            "--rd-dy": `${item.dy}px`,
            "--rd-size": `${item.size}px`,
            "--rd-color": String(item.color || "#ffffff"),
            "--rd-life": `${item.lifeMs}ms`,
            "--rd-delay": `${item.delayMs}ms`,
          }}
        />
      );
    }

    if (item?.type === "floater") {
      return (
        <span
          key={item.id}
          className="reaction-particle reaction-particle--floater"
          style={{
            "--rf-x": `${item.x}px`,
            "--rf-y": `${item.y}px`,
            "--rf-dx": `${item.dx}px`,
            "--rf-dy": `${item.dy}px`,
            "--rf-size": `${item.size}px`,
            "--rf-rot": `${item.rotate}deg`,
            "--rf-rot-end": `${item.rotateEnd}deg`,
            "--rf-life": `${item.lifeMs}ms`,
            "--rf-delay": `${item.delayMs}ms`,
          }}
        >
          {item.emoji || "❤️"}
        </span>
      );
    }

    return (
      <span
        key={item.id}
        className="reaction-particle reaction-particle--emoji"
        style={{
          "--re-x": `${item.x}px`,
          "--re-y": `${item.y}px`,
          "--re-dx": `${item.dx}px`,
          "--re-dy": `${item.dy}px`,
          "--re-rot": `${item.rotate}deg`,
          "--re-size": `${item.size}px`,
          "--re-life": `${item.lifeMs}ms`,
          "--re-delay": `${item.delayMs}ms`,
        }}
      >
        {item.emoji || "❤️"}
      </span>
    );
  };

  return (
    <div className="reaction-particles-layer" aria-hidden="true">
      {particles.map(renderItem)}
    </div>
  );
}
